<div class="container">
  <div class="left rounded-visible-container"><ng-content select="[left]"></ng-content></div>
  <div class="center rounded-visible-container" [class.retracted-center-container]="retractedCenter && windowWidth < 1920"
       [class.maximized-center-container]="!retractedCenter && windowWidth >= 1920"
       [class.expanded-center-container]="!retractedCenter && windowWidth < 1920">
<!--    <div class="retract-button" (click)="retractCenter()" [@fade]="clearContentCenter ? 'fadeOut' : 'fadeIn'">-->
<!--      <i class="fa-regular fa-compress"></i>-->
<!--    </div>-->
    <div class="button-expand" *ngIf="clearContentCenter" (click)="expandCenter()"><i class="fa-solid fa-caret-right fa-beat-fade"></i></div>
    <div class="content" [class.retracted-center-content]="retractedCenter" [class.expanded-center-content]="!retractedCenter" ><ng-content select="[center]"></ng-content></div>
  </div>
  <div class="right rounded-visible-container" [class.retracted-right-container]="retractedRight" [class.expanded-right-container]="!retractedRight">
<!--    <div class="retract-button" (click)="retractRight()" [@fade]="clearContentRight ? 'fadeOut' : 'fadeIn'">-->
<!--      <i class="fa-regular fa-compress"></i>-->
<!--    </div>-->
    <div class="button-expand" *ngIf="clearContentRight" (click)="expandRight()"><i class="fa-solid fa-caret-left fa-beat-fade"></i></div>
    <div class="content" [class.retracted-right-content]="retractedRight" [class.expanded-right-content]="!retractedRight" ><ng-content select="[right]"></ng-content></div>
  </div>
</div>
